import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class UserPermissionViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_PERMISSION_VIEW = '/api/user-permission-view';
        this.GET_USER_PERMISSION_LIST = '/get-list';
    }

    async getUserPermissionList(permissionBody) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.USER_PERMISSION_VIEW + this.GET_USER_PERMISSION_LIST;
            const permissionList = this.fetch(url, {
                   method:'POST',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(permissionBody)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return permissionList;
        } catch(err) {
            console.log(err);
        }
    }
}

export default UserPermissionViewService;
